import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { TmsWebBaseEditCreateService } from 'tms-web-shared';
import { UserPrinterDocument } from '../models';

@Injectable({
  providedIn: 'root',
})
export class UserPrinterDocumentService extends TmsWebBaseEditCreateService<UserPrinterDocument, UserPrinterDocument> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('UserPrinterDocument', $localize`User Printer Document`);
  }

  getAllDocuments(userPrinterId: string): Observable<UserPrinterDocument[]> {
    return this.httpService.get<UserPrinterDocument[]>(`${this.apiUrl}/GetAllDocuments?id=${userPrinterId}`);
  }

  getForDocument(documentDescription: string): Observable<UserPrinterDocument> {
    return this.httpService.get<UserPrinterDocument>(
      `${this.apiUrl}/GetForDocument?documentDescription=${encodeURIComponent(documentDescription)}`,
    );
  }

  updateUserPrinterDocuments(userPrinterId: string, documentIds: string[]): Observable<void> {
    return this.httpService.post(`${this.apiUrl}/UpdateUserPrinterDocuments`, {
      userPrinterId,
      documentIds,
    });
  }
}
